import React from 'react';
import Checkbox from 'Components/DesignSystem/Checkbox/Checkbox';

/**
 * DeltaTable's row / header checkbox, on the DS `Checkbox` since 2026-09-07 — it was a
 * bare native `<input>` that could not theme and had no accessible name.
 *
 * The LEGACY prop contract is preserved so neither call site changed:
 * - `checked` arrives as `"checked" | false` (DeltaTable passes `selected === 1 && "checked"`)
 *   and is coerced to the boolean the DS component wants;
 * - `indeterminate` is written to the input node by the DS component itself (the old
 *   wrapper's useEffect is gone with it);
 * - `onChange` still receives the native change EVENT — the DS `(checked, event)`
 *   signature is adapted back here.
 * The testid stays `components-indeterminatecheckbox-input-1`, on the real `<input>`
 * (⚠ pre-existing wart: it is static, so it duplicates across rows — scope queries to
 * the row). `aria-label` defaults to "Select row"; the header passes "Select all rows".
 */
export const IndeterminateCheckbox = React.forwardRef(
    ({ indeterminate, checked, onChange, 'aria-label': ariaLabel, 'data-testid': dataTestId, ...rest }: any, ref) => {
        return (
            <Checkbox
                {...rest}
                ref={ref as React.Ref<HTMLInputElement>}
                size="sm"
                /* inline-flex so the td's legacy tw-text-center still centres the box */
                className="tw-inline-flex tw-align-middle"
                checked={!!checked}
                indeterminate={!!indeterminate}
                aria-label={ariaLabel ?? 'Select row'}
                onChange={(_checkedNow: boolean, event?: React.ChangeEvent<HTMLInputElement>) => {
                    if (event) onChange?.(event);
                }}
                data-testid={dataTestId ?? 'components-indeterminatecheckbox-input-1'}
            />
        );
    }
);
